var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SolicitanteInspComponent } from './solicitante-insp/solicitante-insp.component';
import { Store } from '@ngrx/store';
import * as FormActions from '../../../reducers/actions/forms.actions';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';
import { PerfilComponent } from '../../perfil/perfil.component';
import { UserService } from 'src/app/services/user.service';
var CrearInspeccionComponent = /** @class */ (function () {
    function CrearInspeccionComponent(dialog, _formBuilder, snackBar, _router, store, claveUnicaService, _userService) {
        this.dialog = dialog;
        this._formBuilder = _formBuilder;
        this.snackBar = snackBar;
        this._router = _router;
        this.store = store;
        this.claveUnicaService = claveUnicaService;
        this._userService = _userService;
        //////////////////////////////////////////
        this.isLinear = false;
        this.rol = new FormControl("");
        this.dir = new FormControl("");
        this.num = new FormControl("");
        this.displayedColumns = ["rol", "direccion", "actions"];
        this.identity = this._userService.getIdentity();
        this.firstFormGroup = this._formBuilder.group({
            rut: ["", [Validators.required]],
            dv: ["", [Validators.required]],
            mod_solicitante: this._formBuilder.group({
                nombre: ["", [Validators.required]],
                apellido_p: [""],
                apellido_m: [""],
                calle: ["", [Validators.required]],
                num: ["", [Validators.required]],
                complemento: [""],
                telefono: [""],
                cel: ["", [Validators.required]],
                ciudad: [""],
                comuna: [""],
                email: ["", [Validators.required, Validators.email]],
            }),
        });
        this.secondFormGroup = this._formBuilder.group({
            rol: this.rol,
            dir: this.dir,
            num: this.num,
        });
        this.thirdFormGroup = this._formBuilder.group({});
        this.quarterFormGroup = this._formBuilder.group({});
        this.resumenFormGroup = this._formBuilder.group({});
    }
    CrearInspeccionComponent.prototype.ngOnInit = function () {
    };
    CrearInspeccionComponent.prototype.cerrar_vista = function () {
        this._router.navigate(["/inicio"]);
    };
    CrearInspeccionComponent.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.store.dispatch(new FormActions.FormUpdate('0', ''));
                        sessionStorage.removeItem("identity-domCloud");
                        sessionStorage.removeItem("token-domCloud");
                        return [4 /*yield*/, this.claveUnicaService.logoutClaveUnica()];
                    case 1:
                        response = _a.sent();
                        console.log('Deslogeo exitoso:', response);
                        this.snackBar.open("Se ha cerrado sesión", "Cerrar", {
                            duration: 3000,
                        });
                        this.back();
                        return [2 /*return*/];
                }
            });
        });
    };
    CrearInspeccionComponent.prototype.openPerfil = function () {
        this.dialog.open(PerfilComponent);
    };
    CrearInspeccionComponent.prototype.back = function () {
        this._router.navigate(['/inicio']);
    };
    return CrearInspeccionComponent;
}());
export { CrearInspeccionComponent };
